import React, { useEffect, useRef } from 'react';

interface ImageUploadProgressCompProps {
    show: boolean;
    progress: number;
    errorMessage: string;
    onClose: () => void;
    onShown: () => void;
}

const ImageUploadProgressComp: React.FC<ImageUploadProgressCompProps> = ({ show, progress, errorMessage, onClose, onShown }) => {

    const modalRef = useRef<HTMLDivElement | null>(null);
    const bsModalRef = useRef<any>(null);

    useEffect(() => {
        if (modalRef.current) {
            bsModalRef.current = new (window as any).bootstrap.Modal(modalRef.current);
            modalRef.current.addEventListener('hidden.bs.modal', onClose);
            if (onShown) {
                modalRef.current.addEventListener('shown.bs.modal', onShown);
            }
        }
        return () => {
            modalRef.current?.removeEventListener('hidden.bs.modal', onClose);
            if (onShown) {
                modalRef.current?.removeEventListener('shown.bs.modal', onShown);
            }
        };
    }, []);

    useEffect(() => {
        if (show) {
            bsModalRef.current?.show();
        } else {
            bsModalRef.current?.hide();
        }
    }, [show]);

    return (
        <div className="modal fade" tabIndex={-1} ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" >
            <div className="modal-dialog">
                <div className="modal-content rounded-0">
                    <div className="modal-header">
                        <h5 className="modal-title">Uploading Logo</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => bsModalRef.current?.hide()}
                        ></button>
                    </div>
                    <div className="modal-body">
                        {errorMessage && errorMessage !== "" ? (
                            <div className="alert alert-danger" role="alert">{errorMessage}</div>
                        ) : (
                            <div className="progress mt-3 mb-3">
                                <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}></div>
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </div >
    )
}

export default ImageUploadProgressComp